import { FC } from "react";

import type { ErrorEvent } from "@tsmono/inspect-common/types";
import { ANSIDisplay } from "@tsmono/react/components";
import { formatDateTime } from "@tsmono/util";

import { EventPanel } from "./event/EventPanel";
import { EventNode } from "./types";

interface ErrorEventViewProps {
  eventNode: EventNode<ErrorEvent>;
  className?: string;
}

export const ErrorEventView: FC<ErrorEventViewProps> = ({
  eventNode,
  className,
}) => {
  const event = eventNode.event;
  return (
    <EventPanel
      eventNodeId={eventNode.id}
      title="Error"
      className={className}
      subTitle={
        event.timestamp ? formatDateTime(new Date(event.timestamp)) : undefined
      }
      icon="error"
    >
      <ANSIDisplay
        output={event.error.traceback_ansi}
        style={{
          fontSize: "clamp(0.3rem, 1.1vw, 0.8rem)",
          margin: "0.5em 0",
        }}
      />
    </EventPanel>
  );
};
